import React from 'react';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='container'>
        <div className='footer-wr'>
          <div className='footer__wrapper'>
            {/* Linke Seite */}
            <div className='footer__left'>
              <div className='footer__icon'>→</div>

              <ul className='footer__nav'>
                <li>
                  <a href='#team'>Über uns</a>
                </li>
                <li>
                  <a href='#services'>Unsere Leistungen</a>
                </li>
                <li>
                  <a href='#reviews'>Kundenbewertungen</a>
                </li>
                <li>
                  <a href='#contact'>Kontakt</a>
                </li>
              </ul>
            </div>

            {/* Rechte Seite */}
            <div className='footer__right'>
              <p className='footer__address'>Krayer Str. 45, 45276 Essen</p>
              <span className='footer__time'>
                Öffnungszeiten:
                <br />
                Montag–Freitag: 09:00–18:00 Uhr
                <br />
                Samstag: 09:00–14:00 Uhr
              </span>

              <a
                href='tel:+4917670729363'
                className='footer__phone'>
                +49 176 70729363
              </a>
              <span className='footer__label'>Kundenhotline</span>
            </div>
          </div>

          {/* Logo und unterer Bereich */}
          <div className='footer__bottom'>
            <h2 className='footer__logo'>
              <img
                src='./img/logo.png'
                alt=''
              />
            </h2>
            <div className='footer__credits'>
              <span>
                © 2025 Melik Kotoian & Melik Kotoyan – Ihr Partner für
                professionelle Reinigung
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
